import React, { ReactElement, ReactNode, MouseEvent, memo } from 'react';
import classNames from 'classnames';
import { Box, BoxProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useResponsive from '../../hooks/useResponsive';

import StyledSubmitButton from './StyledSubmitButton';

export interface IConfirmStepButtonProps extends BoxProps {
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  text?: string;
  disabled?: boolean;
  alwaysMobile?: boolean;
  children?: ReactNode;
  type?: 'submit' | 'button';
}

const useStyles = makeStyles(({ palette, zIndex }) => ({
  mobileView: {
    position: 'fixed',
    bottom: 0,
    backgroundColor: palette.common.white,
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
    zIndex: zIndex.appBar,
  },
}));

const ConfirmStepButton = ({
  text = 'Submit',
  type = 'button',
  disabled = false,
  alwaysMobile = false,
  onClick = () => {},
  children,
  ...boxProps
}: IConfirmStepButtonProps): ReactElement => {
  const { isMobile } = useResponsive();
  const classes = useStyles();
  return (
    <Box
      className={classNames('confirmStepButton-ie', { [classes.mobileView]: isMobile || alwaysMobile })}
      width={1}
      mt={3}
      py={[2, 0]}
      px={3}
      textAlign="center"
      {...boxProps}
    >
      {children}
      <StyledSubmitButton width="100%" onClick={onClick} disabled={disabled} type={type}>
        {text}
      </StyledSubmitButton>
    </Box>
  );
};

export default memo(ConfirmStepButton);
